import { render, staticRenderFns } from "./RightAreaContent.vue?vue&type=template&id=6d9b7026&scoped=true"
import script from "./RightAreaContent.vue?vue&type=script&lang=js"
export * from "./RightAreaContent.vue?vue&type=script&lang=js"
import style0 from "./RightAreaContent.vue?vue&type=style&index=0&id=6d9b7026&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b7026",
  null
  
)

export default component.exports